import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import ActionTypeFilter from "./components/action-type-filter";
import Filters from "./components/global-filter";
import Table from "./components/table";
import UserModal from "./components/modal/users";

import { fetchUsers } from "../../../actions/customer";

const RemediationTrusted = () => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState({});
  const id = useSelector(
    (state) =>
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
  );
  let users = useSelector((state) => state?.customer?.userList?.data);

  const [search, setSearch] = useState("");

  useEffect(() => {
    if (id) {
      fetchUsers(id, dispatch, category, "remediation-mode");
    }
  }, [dispatch, id, category]);

  let mapData =
    search == ""
      ? users
      : users?.filter(
          (row) =>
            row?.fullName?.toLowerCase()?.indexOf(search?.toLowerCase()) !=
              -1 ||
            row?.email?.toLowerCase()?.indexOf(search?.toLowerCase()) != -1
        );

  const addModal = () => {
    setShowModal(true);
  };

  const editModalHandler = (row) => {
    setUserData({
      _id: row._id,
      company: row?.company || "",
      email: row?.email || "",
      fullName: row?.fullName || "",
      companyWebsite: row?.companyWebsite || "",
      role: row?.role || "",
      accessLevel: row?.accessLevel || "remediation-mode",
      internalExternalLevel: row?.internalExternalLevel || "",
      Remediation: true,
    });
    setShowModal(true);
  };

  return (
    <>
      <div className="row clearfix">
        <div className="col-sm-2"></div>
        <div className="col-sm-9" style={{ padding: "0" }}>
          <ActionTypeFilter category={category} setCategory={setCategory} />
          <Filters
            addModal={addModal}
            setSearch={setSearch}
            search={search}
            users={users}
          />
          <Table mapData={mapData} editModalHandler={editModalHandler} />
        </div>
      </div>
      <UserModal
        orgId={id}
        showModal={showModal}
        setShowModal={setShowModal}
        userData={userData}
      />
    </>
  );
};

export default RemediationTrusted;
